module.exports = __webpack_public_path__ + "55821e63fb9492fdf5d6d6225fe52173.pdf";